class Video {
    constructor() {
      this.playButtons = document.querySelectorAll('.js-video-play');
      this.init();
    }
  
    init() {
      this.playButtons.forEach(button => {
        button.addEventListener('click', this.handlePlay.bind(this));
      });
    }
  
    handlePlay(event) {
      const button = event.currentTarget;
      const template = button.nextElementSibling;
      const videoContent = template.content.cloneNode(true);
      
      button.style.display = 'none';
      button.parentNode.appendChild(videoContent);
      
      const video = button.parentNode.querySelector('.js-video');
      if (video) {
        video.play();
      }
    }
  }
  
  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    new Video();
  });